// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DkjMdUSlagkhpklCcIwB{background:var(--black-30);flex-direction:column;display:flex;position:fixed;top:0;bottom:0;left:0;right:0;overflow:auto}.DkjMdUSlagkhpklCcIwB.cE5gz3EIdEBs7ra2Z69r{background:0 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `DkjMdUSlagkhpklCcIwB`,
	"hide": `cE5gz3EIdEBs7ra2Z69r`
};
export default ___CSS_LOADER_EXPORT___;
